import type { SolverPhaseNeedsModalProps } from "@/components/modals/SolverPhaseNeedsModal.types.tsx";
import SolverPhaseConfig, { buildSolverPhaseConfigController } from "@/components/sections/SolverPhaseConfig.tsx";
import React, { useEffect } from "react";
import Modal from "./Modal";
import SolverPhaseNeeds, { buildSolverPhaseNeedsController } from "@/components/sections/SolverPhaseNeeds.tsx";







/**
 * Main component
 * @param param0
 * @returns 
 */
const SolverPhaseNeedsModal: React.FC<SolverPhaseNeedsModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        title,
        confirmLabel = "Confirmer",
        cancelLabel = "Annuler",
        confirmDisabled = false,
        phase = {},
        phaseId ,
        schedule
    }) => {
    
    const ctrl = buildSolverPhaseNeedsController(phase,phaseId,schedule);
    //const [editData , setEditData] = useState({...{},...solverConfigs});


    //@ Reset editData each time modal is opened (Not sure if this is the proper way of doing it)
    useEffect(()=>{
        if(open){
            ctrl.setEditData({...{},...phase});
        }
    },[open]);

    const handleConfirm = () => {
        onConfirm(ctrl.editData);
        onClose();
    };

    const onRoleDayClick = (roleId:string,dayId:string)=>{
        const newMapOfNeeds:typeof ctrl.editData.mapOfNeedSettings = {...{}, ...(ctrl.editData.mapOfNeedSettings ||{})};
        const curNeeds =newMapOfNeeds?.[roleId] || {apply  :false , mapOfDayOptions : {}};
        const mapOfDayOptions:typeof curNeeds.mapOfDayOptions ={...{},...(curNeeds.mapOfDayOptions||{})};
        const newMapOfDayOptions:typeof curNeeds.mapOfDayOptions ={};
        const curNeedsDay = (mapOfDayOptions)?.[dayId] ||{apply :false};

        const newApplyForDay = !curNeedsDay.apply;
        mapOfDayOptions[dayId] = {apply : newApplyForDay}

        var hasDay = false;
        var entries =Object.entries(mapOfDayOptions);
        for (const [key, value] of entries) {
            if(value && value.apply !== false){
                newMapOfDayOptions[key] = value;
                hasDay = true;
            }
        }
    
 
        if(hasDay){ 
            newMapOfNeeds[roleId] = {apply :true , mapOfDayOptions :newMapOfDayOptions }
        }else{
            if(newMapOfNeeds[roleId]){delete newMapOfNeeds[roleId]}
        }

        ctrl.setEditData({
            ...ctrl.editData, 
            ...{
                mapOfNeedSettings : newMapOfNeeds
            }
        })
    }
    const onRoleAllDaysClick = (roleId:string)=>{
        const newMapOfNeeds:typeof ctrl.editData.mapOfNeedSettings = {...{}, ...(ctrl.editData.mapOfNeedSettings ||{})};
        const curNeeds =newMapOfNeeds?.[roleId] || {apply  :false , mapOfDayOptions : {}};
        const mapOfDayOptions:typeof curNeeds.mapOfDayOptions ={...{},...(curNeeds.mapOfDayOptions||{})};
        
        //var hasDay = false;
        var entries =Object.entries(mapOfDayOptions);
        let willToggleAll = !entries.length;
        for (const [key, value] of entries) {
            if(!(value && value.apply !== false)){
                willToggleAll = true;
            }
        }
    
 
        if(willToggleAll){ 
            const newMapOfDayOptions:typeof curNeeds.mapOfDayOptions ={};
            ["0","1","2","3","4","5","6"].forEach((id)=>{
                newMapOfDayOptions[id] ={apply :true}
            });
            newMapOfNeeds[roleId] = {apply :true , mapOfDayOptions :newMapOfDayOptions }
        }else{
            if(newMapOfNeeds[roleId]){delete newMapOfNeeds[roleId]}
        }

        ctrl.setEditData({
            ...ctrl.editData, 
            ...{
                mapOfNeedSettings : newMapOfNeeds
            }
        })
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            size="xl"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={confirmDisabled}
                        className={`inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${confirmDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-green-700"}`}
                    >
                        {confirmLabel}
                    </button>
                </>
            }
        >
            <SolverPhaseNeeds 
                onRoleAllDaysClick={onRoleAllDaysClick}
                onRoleDayClick={onRoleDayClick}
                controller={ctrl}> 
            </SolverPhaseNeeds>

        </Modal>
    );
};

export default SolverPhaseNeedsModal;
